
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { GET_PO_BY_PO_NUMBER, BULK_APPROVE_PO, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import { loaderService } from "../../../common/custom-loader/loader-service";
import React, { useState, useEffect } from "react";

import moment from 'moment';
import { useLocation } from "react-router-dom";
import { PRINT_DOWNLOAD_DATA } from '../../../common/URLs';
import { PROD } from '../../../common/constants';
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { Container, Button, Box, Card, CardContent, Grid, Divider, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import jwt from 'jwt-decode';
import { toast } from 'react-toastify';
import { Fab } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { PoPrintWrapper } from "../poPrintWrapper";
import apiClient from "../../../axios";

function Sto() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const stoDetails = useLocation().state?.selectedRow;
  const state = useLocation().state;
  const poNumber = stoDetails?.poNumber ? stoDetails?.poNumber : stoDetails?.pitPono;
  const [stakeholderDetails, setStakeholderDetails] = useState({});
  const [ponumberDetails, setPonumberDetails] = useState();
  const [downloadGrn, setDownloadGrn] = useState();
  const [poList, setpoList] = useState([]);
  const [bulkApprovePo, setbulkApprovePo] = useState();
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => { setLogModalOpen2(false); getPodetailsbyponumber(); }

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  useEffect(() => {
    if (poNumber) {
      getPodetailsbyponumber();
    }
    getStakeDetails();
  }, []);


  function getStakeDetails() {
    console.log(decoded.extension_URN)
    if (decoded.extension_URN) {
      loaderService.showLoader()
      apiClient
        .post(GET_STAKEHOLDER_CATEGORY,
          {
            "urn": decoded.extension_URN,
            "type": ""
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setStakeholderDetails(response.data);

          loaderService.hideLoader()
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader()
          toast.error(error.message);
        });
    }
  }

  const getPodetailsbyponumber = (e) => {
    loaderService.showLoader();
    apiClient
      .post(GET_PO_BY_PO_NUMBER,
        {
          "poNumber": poNumber
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setPonumberDetails(response.data.poDetails);
        // console.log("ponumber", ponumberDetails)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getDownloadgrn = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": poNumber,
          "printDetailsType": "sto"
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadGrn(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onConfirmApprove = (e) => {
    handleConfirmClose();
    onApprove(e);
  }

  const onApproveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onConfirmReject = (e) => {
    handleConfirmClose2();
    onReject(e);
  }

  const onRejectButtonClick = (e) => {
    handleConfirmOpen2();
  }

  const onApprove = (e) => {
    toApproveBulk(true);

  }
  const onReject = (e) => {
    toApproveBulk(false);
  }

  const toApproveBulk = (approval) => {
    loaderService.showLoader();
    apiClient
      .post(BULK_APPROVE_PO,
        {
          "poNumberList": [ponumberDetails?.poNumber],
          "isApproved": approval,
          "approvedBy": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setbulkApprovePo(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (bulkApprovePo) {
      if (bulkApprovePo.isSuccess === true) {
        toast.success(bulkApprovePo?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(bulkApprovePo?.message ? bulkApprovePo?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [bulkApprovePo]);

  const columns = [
    // { field: 'lineNo', headerName: t('pit.lineNo'), width: 100 },
    { field: 'itemCode', headerName: t('pit.itemCode'), width: 100 },
    { field: 'poMaterialType', headerName: t('pit.itemDesc'), width: 140 },
    { field: 'poQuantity', headerName: t('pit.quantity'), width: 100 },
    { field: 'poUnitOfMeasure', headerName: t('pit.uom'), width: 100 },
    { field: 'shipTo', headerName: t('pit.shipTo'), width: 200,
      renderCell: (params) => {
        return params.row.destinationName + ', ' + params.row.destinationStakeholderAddress
      }
     },
    { field: 'billTo', headerName: t('pit.billTo'), width: 200,
      renderCell: (params) => {
        return params.row.customerName + ', ' + params.row.customerAddress
      }
     },
    {
      field: 'poDeliveryDate', headerName: t('pit.validityDate'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    {
      field: 'poUnitPrice', headerName: t('pit.price'), width: 100,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'totalAmount', headerName: t('pit.total'), width: 180,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'totalCGST', headerName: "Total CGST", width: 150,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'totalSGST', headerName: "Total SGST", width: 150,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'totalIGST', headerName: "Total IGST", width: 150,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'totalTax', headerName: "Total Tax", width: 150,
      valueGetter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'poAmount', headerName: "Total (Inc. Taxes) (INR)", width: 180,
      valueGetter: (params) => params.value?.toFixed(2)
    },
  ];

const handleBackButton = () => {
  if(state?.screen == "approvalList") {
    navigate('/stoApproval', {
      state: { tabVal: state?.tabVal, tabValueModify: state?.tabValueModify }
    });
  }
  else if(state?.screen == "list") {
    navigate('/stoList', {
      state: { tabVal: state?.tabVal, tabValueModify: state?.tabValueModify }
    });
  }
  else if (state?.screen === "invoicePayment" || state?.screen === "invoice" || state?.pageName === "invoicePayment") {
    navigate('/paymentDashboard/invoicePayment', {
      state: { tabValue: state?.tabValue, stakeholderType: state?.stakeholderType, openGroupId: state?.openGroupId}
    });
  }
  else {
    navigate(-1);
  }
}

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT23</p>}
        <Typography variant="h4" sx={{ mb: 2 }}>
          <Fab onClick={handleBackButton} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> {t('pit.sto')}
        </Typography>
        <Card>
          <CardContent>
            <Stack direction="row" >
              <Typography variant='h6'>{t('pit.stoNo')} :</Typography>
              <Typography style={{ marginTop: "0.5vh", marginLeft: "1vw" }} variant="body2" gutterBottom>{ponumberDetails?.poNumber}</Typography>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
              <Stack direction="column">
                <Typography variant="subtitle1" gutterBottom>{t('pit.vendorDetails')}</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.poStakeholderName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.urn')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.poStakeholderUrn}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.contactPerson')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.poContactPerson}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.phoneNumber')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.poStakeholderPhonNumber}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.address')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.poStakeholderAddress}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="column">
                <Typography variant="subtitle1" gutterBottom>{t('pit.customerDetails')}</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.customerName}
                  </Typography>
                </Stack>
                {/* <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.urn')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.destinationStakeholderUrn}
                  </Typography>
                </Stack> */}
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.contactPerson')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.customerPerson}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.phoneNumber')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.customerPhonNumber}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>{t('pit.address')}: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {ponumberDetails?.customerAddress}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <DataGrid sx={{ marginTop: "4vh" }}
               autoHeight
               getRowHeight={() => 'auto'}
              rows={ponumberDetails ? [ponumberDetails] : []}
              columns={columns}
              hideFooterPagination
            />


          </CardContent>
        </Card>

        <Box display='flex' justifyContent="flex-end" mt={2}>
          <Button variant="contained" onClick={() => getDownloadgrn("download")}>{t('pit.download')}</Button>
          <Button sx={{ ml: 2 }} variant="contained" onClick={() => getDownloadgrn("print")}>{t('pit.print')}</Button>
          {/* {ponumberDetails?.isApproved == 0 && !(stakeholderDetails?.category === 'Grower') &&
            <>
              <Button sx={{ ml: 2 }} variant="contained" onClick={(e) => onApproveButtonClick(e)}>Approve</Button>
              <Button sx={{ ml: 2 }} variant="contained" onClick={(e) => onRejectButtonClick(e)}>
                Reject
              </Button>
            </>} */}
        </Box>

        <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
          <DialogContent>
            <ConfirmPopover title={bulkApprovePo?.message ? bulkApprovePo?.message : "Error"} hideLink={true} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLogModalClose2}>OK</Button>
          </DialogActions>
        </Dialog>
      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve STO" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject STO" />
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={bulkApprovePo?.message ? bulkApprovePo?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default Sto;